<div class="catalog-container">
  <!-- Header -->
  <div class="header">
    <!-- Breadcrumbs -->
    <div class="breadcrumbs">
      <!-- Go Back Action -->
      <button class="action-btn secondary-btn icon-btn" (click)="goBack()">
        <span class="icon">
          <img src="assets/icones/close_icon.svg" alt="" />
        </span>
      </button>
      <span>
        <div class="breadcrumb-item">
          {{ (source === 'catalogs' ? 'Catalogs.catalogs' : 'agent.title') | translate }}
        </div>
      </span>
      <img src="assets/icones/arrow_to_right.svg" alt="" />
      <span class="catalog-name">{{ !isEdit ? ('Catalogs.new_catalog.new_catalog' | translate) : newCatalog?.name }}</span>
      <span class="tag" [class.positive]="newCatalog.status === 'Approved'">
        {{ (newCatalog.status === 'Draft' ? 'Catalogs.new_catalog.publish_status.draft' : 'Catalogs.new_catalog.publish_status.published') | translate }}
      </span>
    </div>
    <!-- Catalog Actions -->
    <div style="display: flex; gap: 20px; align-items: center">
      <button *ngIf="isEdit" [matMenuTriggerFor]="menu" class="action-btn secondary-btn icon-btn more-btn">
        <span class="icon"><mat-icon>more_vert</mat-icon></span>
      </button>
      <mat-menu #menu="matMenu" yPosition="below" xPosition="before">
        <button mat-menu-item class="download-btn" (click)="downloadCatalog()">
          <app-svg-icon svgIcon="download-cc"></app-svg-icon>
          Download
        </button>
      </mat-menu>
      <!-- <button
        *ngIf="!isEdit"
        class="action-btn primary-btn"
        [disabled]="!isValidToSave('Approved')"
        (click)="save('Approved')"
        [matTooltip]="
          isValidToSave('Approved')
            ? ''
            : this.newCatalog && this.newCatalog.name && this.totalSKUs > 0 && this.assignedCustomers.length > 0
            ? getValidationTooltipMessage()
            : ('Catalogs.new_catalog.actions.cant_publish_tooltip' | translate)
        "
      >
        <span>{{ 'Catalogs.new_catalog..actions.publish' | translate }}</span>
      </button> -->
      <ng-container *ngIf="source === 'agents'">
        <!-- <ng-container *ngIf="isEdit"> -->
          <ng-container *ngIf="newCatalog.status === 'Draft'">
            <button class="action-btn secondary-btn save-btn" *appHasPermission="submitPermission()" [disabled]="!isValidToSave('Draft')" (click)="save('Draft')">
              <span class="icon">
                <app-svg-icon svgIcon="save-cc"></app-svg-icon>
              </span>
              <span>{{ 'Catalogs.new_catalog.actions.save' | translate }}</span>
            </button>
            <button class="action-btn primary-btn" *appHasPermission="submitPermission()" [disabled]="!isValidToSave('Approved')" (click)="save('Approved')">
              <span>{{ 'Catalogs.new_catalog.actions.publish' | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="newCatalog.status === 'Approved'">
            <button class="action-btn primary-btn" *appHasPermission="submitPermission()" [disabled]="!isValidToSave('Approved')" (click)="save('Approved')">
              <app-svg-icon svgIcon="reload" iconSize="small"></app-svg-icon>
              <span>{{ 'Catalogs.share_catalog.update_button' | translate }}</span>
            </button>
          </ng-container>
        <!-- </ng-container> -->
      </ng-container>
      <ng-container *ngIf="source === 'catalogs'">
        <!-- <ng-container *ngIf="isEdit"> -->
          <ng-container *ngIf="newCatalog.status === 'Draft'">
            <button
              class="action-btn secondary-btn save-btn"
              *appHasPermission="submitPermission()"
              [disabled]="!isValidToSave('Draft')"
              (click)="save('Draft')"
              data-testid="save-catalog-btn"
            >
              <span class="icon">
                <app-svg-icon svgIcon="save-cc"></app-svg-icon>
              </span>
              <span>{{ 'Catalogs.new_catalog.actions.save' | translate }}</span>
            </button>
            <button
              class="action-btn primary-btn"
              *appHasPermission="submitPermission()"
              [disabled]="!isValidToSave('Approved')"
              (click)="save('Approved')"
              data-testid="publish-catalog-btn"
            >
              <span>{{ 'Catalogs.new_catalog.actions.publish' | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="newCatalog.status === 'Approved'">
            <button
              class="action-btn primary-btn"
              *appHasPermission="submitPermission()"
              [disabled]="!isValidToSave('Approved')"
              (click)="save('Approved')"
              data-testid="update-catalog-btn"
            >
              <app-svg-icon svgIcon="reload" iconSize="small"></app-svg-icon>
              <span>{{ 'Catalogs.share_catalog.update_button' | translate }}</span>
            </button>
          </ng-container>
          <!-- <button class="action-btn primary-btn" [disabled]="!isValidToSave('Approved')" (click)="openShareCatalog('edit')">
            <span>{{ 'Catalogs.new_catalog.actions.publish' | translate }}</span>
          </button> -->
        <!-- </ng-container> -->
      </ng-container>
    </div>
  </div>
  <!-- Content -->
  <div class="catalog-content">
    <!-- Left Panel -->
    <div class="left-panel">
      <div class="header">{{ 'Catalogs.new_catalog.tabs.settings' | translate }}</div>
      <div class="content">
        <app-new-catalog-settings [catalogType]="source" (isAllFormsValid)="isAllFormsValid($event)"></app-new-catalog-settings>
      </div>
    </div>
    <div class="right-panel">
      <div class="tabs">
        <div
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'products'"
          [class.active]="rightPanelActiveTab === 'products'"
          (click)="rightPanelActiveTab = 'products'"
          data-testid="products-tab"
        >
          {{ 'Catalogs.new_catalog.tabs.products' | translate }}
        </div>
        <div
          *ngIf="source === 'agents'"
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'agents'"
          [class.active]="rightPanelActiveTab === 'agents'"
          (click)="rightPanelActiveTab = 'agents'"
        >
          {{ 'Catalogs.new_catalog.tabs.agents' | translate }}
        </div>
        <div
          *ngIf="source === 'catalogs'"
          class="tab"
          role="tab"
          [attr.aria-selected]="rightPanelActiveTab === 'audience'"
          [class.active]="rightPanelActiveTab === 'audience'"
          (click)="rightPanelActiveTab = 'audience'"
          data-testid="audience-tab"
        >
          {{ 'Catalogs.new_catalog.tabs.audience' | translate }}
        </div>
        <!-- Pricebook tab hidden front-end-wide due to business decision (WB-6694). Not deleted — gated by loyaltyEnabled (forced false). -->
        <div *ngIf="isEdit && featureFlags.loyaltyEnabled" class="tab" role="tab" [attr.aria-selected]="rightPanelActiveTab === 'price-rules'" [class.active]="rightPanelActiveTab === 'price-rules'" (click)="rightPanelActiveTab = 'price-rules'">
          {{ 'Catalogs.new_catalog.tabs.price_book' | translate }}
        </div>
        <div style="display: flex; align-items: center; gap: 20px; margin-left: auto">
          <ng-container *ngIf="rightPanelActiveTab === 'products' && newCatalog?.products?.length">
            <span class="secondary-text" style="text-align: center">{{ totalSKUs }} SKUs</span>
            <span class="secondary-text" style="text-align: center">{{ totalStock }} {{ 'Catalogs.new_catalog.tabs.total_stock' | translate }}</span>
            <div *ngIf="source === 'catalogs'" class="standard-input standard-input-currency">
              <mat-select [formControl]="currencyControl">
                <mat-option *ngFor="let currency of availableCurrencies" [value]="currency.id">{{ currency.name }}</mat-option>
              </mat-select>
            </div>
            <button
              class="action-btn secondary-btn"
              *appHasPermission="submitPermission()"
              style="color: #001792"
              (click)="editCatalogProducts()"
              data-testid="view-and-edit-products-btn"
            >
              <span class="icon">
                <app-svg-icon svgIcon="expand-cc"></app-svg-icon>
              </span>
              <span style="text-transform: none">{{ 'Catalogs.new_catalog.actions.view_and_edit' | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="rightPanelActiveTab === 'agents'">
            <span class="secondary-text" style="text-align: center">
              {{ assignedAgents }} {{ 'Catalogs.new_catalog.tabs.agents_assigned' | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="rightPanelActiveTab === 'audience'">
            <span class="secondary-text" style="text-align: center">
              {{ companiesMetadata?.count ?? assignedCustomers.length }} {{ 'Catalogs.new_catalog.tabs.audience_assigned' | translate }}
            </span>
          </ng-container>
          <ng-container
            *ngIf="rightPanelActiveTab === 'audience' && assignedCustomers.length > 0"
          >
            <button
              class="action-btn secondary-btn"
              *appHasPermission="submitPermission()"
              style="color: #6449DB;"
              (click)="openAddPortfolioDialog()"
              data-testid="add-companies-btn"
            >
              <span class="icon"
                ><app-svg-icon svgIcon="plus-cc"></app-svg-icon
              ></span>
              <span class="action-text">{{ "agent.actions.add_company" | translate }}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="rightPanelActiveTab === 'audience' && showDeleteButton">
            <button class="action-btn secondary-btn icon-btn" *appHasPermission="submitPermission()" style="border-color: #970000" (click)="deleteAudience()">
              <span class="icon">
                <app-svg-icon svgIcon="trash-cc" style="color: #970000"></app-svg-icon>
              </span>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="tab-content-wrapper">
        <app-new-catalog-products *ngIf="rightPanelActiveTab === 'products'" [currencyControl]="currencyControl"></app-new-catalog-products>
        <app-new-catalog-agents *ngIf="rightPanelActiveTab === 'agents'"></app-new-catalog-agents>
        <div class="audience-list-container" *ngIf="source === 'catalogs' && rightPanelActiveTab === 'audience'">
          <app-new-catalog-audience-list *ngIf="assignedCustomers.length > 0 else noLocations" 
            [initialAssignedCustomers]="assignedCustomers"
            [companiesMetadata]="companiesMetadata"
            [isLoadingMore]="isLoadingMoreCompanies"
            (loadMore)="loadMoreCompanies()"
            (assignedLocationsChange)="assignedLocationsChange($event)"
            (selectedCompaniesChange)="selectedCompaniesChange($event)"
            (selectedCompaniesChanged)="selectedCompaniesChanged($event)"
            [selectedCompaniesChangedOut]="clearSelectedCompanies"
            [isEdit]="isEdit"
            (deleteLocations)="deleteLocations($event)"
            (sortChange)="onSortChange($event)"
          ></app-new-catalog-audience-list>
        </div>
        <ng-template #noLocations>
          <div class="no-locations-container">
            <img src="assets/images/shop.svg" alt="" />
            <span class="no-data-msg">
              {{ 'Catalogs.new_catalog.audience.no_data_msg' | translate }}
            </span>
            <p class="no-data-desc" [innerHTML]="'Catalogs.new_catalog.audience.no_data_desc' | translate"></p>
            <button
              class="action-btn primary-btn"
              *appHasPermission="submitPermission()"
              (click)="openAddPortfolioDialog()"
              data-testid="add-companies-btn-empty"
            >
              <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
              <span>{{ 'agent.actions.add_companies' | translate }}</span>
            </button>
          </div>
        </ng-template>
        <div *ngIf="featureFlags.loyaltyEnabled && rightPanelActiveTab === 'price-rules'">
          <app-catalog-price-rules></app-catalog-price-rules>
        </div>
      </div>
    </div>
  </div>
</div>
